<!-- global spinner -->
<ngx-spinner size="small" color="#C97514" type="line-scale"></ngx-spinner>
<app-header *ngIf="showHeader && service.isLoggedIn()"></app-header>
<app-header *ngIf="showHeader && !service.isLoggedIn()"></app-header>
<app-advertisment *ngIf="currUrl != 'homepage' && currUrl != 'profile' && currUrl != 'verfy-account' && currUrl != 'reset-password/:email'"></app-advertisment>
<router-outlet></router-outlet>
<app-footer *ngIf="showHeader"></app-footer>